import { Alert } from "@mantine/core";

interface Props {
  failureReason: string | null;
}

export function HeldEmailFailureAlert({ failureReason }: Props) {
  return failureReason ? (
    <Alert color="orange" title="Last release attempt failed">
      {failureReason}
    </Alert>
  ) : null;
}
